import React, { useState } from 'react';
import { 
  FaPhone, 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaTiktok,
  FaTwitter
} from 'react-icons/fa';
import './Contact.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { contactAPI } from '../../api'; // Import de l'API

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    // Effacer l'erreur quand l'utilisateur commence à taper
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Le nom est requis';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'L\'email est requis';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Format d\'email invalide';
    }
    
    if (!formData.subject.trim()) {
      newErrors.subject = 'L\'objet est requis';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Le message est requis';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Le message doit contenir au moins 10 caractères';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    setSuccessMessage('');
    
    try {
      // Envoi du message via l'API
      const response = await contactAPI.sendMessage(formData);
      
      if (response.success) {
        setSuccessMessage('Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.');
        
        // Réinitialiser le formulaire
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        
        // Effacer le message de succès après 5 secondes
        setTimeout(() => {
          setSuccessMessage('');
        }, 5000);
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      
      if (error.status === 422 && error.errors) {
        // Gestion des erreurs de validation du backend
        setErrors(error.errors);
      } else {
        // Erreur générale
        setErrors({ 
          submit: error.message || 'Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer.' 
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-wrappercontactbigcontain">
      <Header />
      <section className="contact-sectioncontact" id="contact">
        <div className="contact-wrappercontact">
          <div className="contact-headercontact">
            <h2 className="contact-titlecontact">Contactez-nous</h2>
            <div className="contact-linecontact"></div>
            <p className="contact-introcontact">
              Nous sommes là pour répondre à toutes vos questions sur vos études en France
            </p>
          </div>

          <div className="contact-contentcontact">
            <div className="contact-infocontact">
              <h3 className="info-titlecontact">Au téléphone</h3>
              
              <div className="contact-methodscontact">
                <div className="contact-methodcontact">
                  <div className="method-iconcontact">
                    <FaPhone />
                  </div>
                  <div className="method-contentcontact">
                    <h4 className="method-titlecontact">Téléphone</h4>
                    <a href="tel:+33695744027" className="method-detailcontact">
                      +33 6 95 74 40 27
                    </a>
                  </div>
                </div>

                <div className="contact-methodcontact">
                  <div className="method-iconcontact">
                    <FaWhatsapp />
                  </div>
                  <div className="method-contentcontact">
                    <h4 className="method-titlecontact">WhatsApp</h4>
                    <a 
                      href="https://wa.me/33695744027" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="method-detail"
                    >
                      Écrivez-nous sur WhatsApp
                    </a>
                  </div>
                </div>

                <div className="contact-methodcontact">
                  <div className="method-iconcontact">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="method-contentcontact">
                    <h4 className="method-titlecontact">Adresse</h4>
                    <p className="method-detailcontact">
                      Place de l'hôtel des Postes, 13001 Marseille
                    </p>
                  </div>
                </div>

                <div className="contact-methodcontact">
                  <div className="method-iconcontact">
                    <FaEnvelope />
                  </div>
                  <div className="method-contentcontact">
                    <h4 className="method-titlecontact">Email</h4>
                    <a href="mailto:contact@etef.fr" className="method-detailcontact">
                      contact@etef.fr
                    </a>
                  </div>
                </div>
              </div>

              <div className="social-sectioncontact">
                <h3 className="social-titlecontact">Suivez-nous</h3>
                <div className="social-linkscontact">
                  <a 
                    href="https://linkedin.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedin />
                  </a>
                  <a 
                    href="https://instagram.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a 
                    href="https://facebook.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="Facebook"
                  >
                    <FaFacebook />
                  </a>
                  <a 
                    href="https://twitter.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="Twitter"
                  >
                    <FaTwitter />
                  </a>
                  <a 
                    href="https://youtube.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="YouTube"
                  >
                    <FaYoutube />
                  </a>
                  <a 
                    href="https://tiktok.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-linkcontact"
                    aria-label="TikTok"
                  >
                    <FaTiktok />
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form-containercontact">
              <h3 className="form-titlecontact">Dites-nous</h3>
              
              {successMessage && (
                <div className="alert alert-success">
                  {successMessage}
                </div>
              )}
              
              {errors.submit && (
                <div className="alert alert-error">
                  {errors.submit}
                </div>
              )}
              
              <form className="contact-formcontact" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Nom *"
                    className={`form-input ${errors.name ? 'error' : ''}`}
                    disabled={loading}
                  />
                  {errors.name && <div className="error-message">{errors.name}</div>}
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="E-mail *"
                    className={`form-input ${errors.email ? 'error' : ''}`}
                    disabled={loading}
                  />
                  {errors.email && <div className="error-message">{errors.email}</div>}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Objet *"
                    className={`form-input ${errors.subject ? 'error' : ''}`}
                    disabled={loading}
                  />
                  {errors.subject && <div className="error-message">{errors.subject}</div>}
                </div>

                <div className="form-group">
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Rédigez votre message ici... *"
                    className={`form-textarea ${errors.message ? 'error' : ''}`}
                    rows="5"
                    disabled={loading}
                  />
                  {errors.message && <div className="error-message">{errors.message}</div>}
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="loading-spinnercontact">Envoi en cours...</span>
                  ) : (
                    'Envoyer'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;